import { type FC } from 'react';

interface SEOArticle {
  slug: string;
  title: string;
  excerpt: string;
  readTime: string;
  imageUrl: string;
}

const seoArticles: SEOArticle[] = [
  {
    slug: '/oopbuy-spreadsheet-einrichtung',
    title: 'OOPBUY Spreadsheet Einrichtung – Schritt für Schritt Anleitung',
    excerpt: 'Lerne, wie du deinen OOPBUY Spreadsheet in wenigen Minuten einrichtest. Von der Kontoerstellung bis zur ersten Bestellung — alles erklärt für Einsteiger.',
    readTime: '6 Min.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20laptop%20on%20a%20warm%20wooden%20desk%20displaying%20a%20colorful%20spreadsheet%20interface%20with%20a%20cup%20of%20coffee%20beside%20it%20soft%20morning%20sunlight%20through%20sheer%20curtains%20minimalist%20home%20office%20aesthetic%20editorial%20photography%20calm%20productive%20atmosphere&width=800&height=500&seq=seo-card-einrichtung&orientation=landscape',
  },
  {
    slug: '/oopbuy-qc-guide',
    title: 'OOPBUY QC Guide – So funktioniert die Qualitätskontrolle',
    excerpt: 'QC-Bilder richtig bewerten, Mängel erkennen und Retouren vermeiden. Der vollständige Leitfaden für die Qualitätskontrolle deiner Bestellungen aus China.',
    readTime: '8 Min.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Person%20carefully%20inspecting%20a%20pair%20of%20white%20sneakers%20with%20a%20magnifying%20glass%20on%20a%20bright%20clean%20worktable%20with%20soft%20overhead%20lighting%20professional%20quality%20control%20setting%20editorial%20product%20inspection%20photography%20detailed%20texture%20focus&width=800&height=500&seq=seo-card-qc&orientation=landscape',
  },
  {
    slug: '/oopbuy-versand-deutschland',
    title: 'Versand nach Deutschland mit OOPBUY – Alle Optionen im Vergleich',
    excerpt: 'DHL, EMS oder Triangle Shipping? Wir vergleichen alle Versandmethoden, Kosten und Lieferzeiten für deine Bestellungen nach Deutschland.',
    readTime: '7 Min.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20boxes%20stacked%20neatly%20beside%20a%20world%20map%20on%20a%20warm%20cream%20wall%20with%20a%20measuring%20tape%20and%20customs%20forms%20soft%20natural%20light%20editorial%20logistics%20photography%20clean%20organized%20composition&width=800&height=500&seq=seo-card-versand&orientation=landscape',
  },
  {
    slug: '/oopbuy-agent-vergleich',
    title: 'OOPBUY Agent Vergleich 2025 – Den besten Agenten finden',
    excerpt: 'Nicht jeder Agent ist gleich. Wir zeigen dir, worauf es ankommt: Preise, Service, QC-Qualität und Versandgeschwindigkeit im direkten Vergleich.',
    readTime: '9 Min.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20hands%20shaking%20over%20a%20clean%20wooden%20desk%20with%20documents%20spreadsheet%20printouts%20and%20a%20calculator%20soft%20professional%20lighting%20warm%20tones%20business%20partnership%20editorial%20photography%20trustworthy%20atmosphere&width=800&height=500&seq=seo-card-agent&orientation=landscape',
  },
  {
    slug: '/oopbuy-taobao-guide',
    title: 'Taobao Einkaufsguide für Deutsche – Mit OOPBUY zum besten Deal',
    excerpt: 'Taobao richtig nutzen: Von der Produktsuche über die Seller-Bewertung bis zum Kauf. Alle Tipps für deutsche Käufer im größten chinesischen Marktplatz.',
    readTime: '7 Min.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20Taobao%20app%20interface%20on%20a%20warm%20wooden%20surface%20surrounded%20by%20small%20fashion%20accessories%20and%20a%20notebook%20with%20handwritten%20notes%20soft%20natural%20lighting%20editorial%20tech%20lifestyle%20photography&width=800&height=500&seq=seo-card-taobao&orientation=landscape',
  },
  {
    slug: '/oopbuy-weidian-guide',
    title: 'Weidian Guide – Versteckte Schätze finden mit OOPBUY',
    excerpt: 'Weidian ist die Geheimwaffe für Fashion-Liebhaber. Entdecke exklusive Pieces, kleine Seller und limitierte Kollektionen mit dem OOPBUY Spreadsheet.',
    readTime: '6 Min.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20streetwear%20clothing%20pieces%20laid%20out%20on%20a%20warm%20concrete%20floor%20with%20natural%20window%20light%20creating%20interesting%20shadows%20editorial%20fashion%20flat%20lay%20photography%20urban%20aesthetic%20creative%20composition&width=800&height=500&seq=seo-card-weidian&orientation=landscape',
  },
  {
    slug: '/oopbuy-yupoo-guide',
    title: 'Yupoo Integration – Fotoalben clever in den Spreadsheet einbinden',
    excerpt: 'Yupoo-Alben effizient in deinen OOPBUY Workflow integrieren. So verknüpfst du Seller-Fotos direkt mit deinen Bestellungen im Spreadsheet.',
    readTime: '5 Min.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Digital%20camera%20and%20printed%20photo%20albums%20arranged%20on%20a%20warm%20desk%20surface%20beside%20a%20laptop%20showing%20image%20gallery%20interface%20soft%20daylight%20editorial%20content%20creation%20photography%20creative%20workspace%20atmosphere&width=800&height=500&seq=seo-card-yupoo&orientation=landscape',
  },
  {
    slug: '/oopbuy-kosten-sparen',
    title: 'Kosten sparen mit OOPBUY – 10 bewährte Strategien',
    excerpt: 'Versandkosten senken, Batch-Rabatte nutzen und Wechselkurs-Tricks. Mit diesen 10 Strategien sparst du bei jeder Bestellung bares Geld.',
    readTime: '7 Min.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Glass%20jar%20filled%20with%20coins%20and%20a%20small%20plant%20on%20a%20warm%20wooden%20desk%20beside%20a%20notebook%20with%20savings%20calculations%20soft%20golden%20hour%20sunlight%20streaming%20in%20editorial%20finance%20photography%20cozy%20atmosphere&width=800&height=500&seq=seo-card-sparen&orientation=landscape',
  },
  {
    slug: '/oopbuy-batch-bestellungen',
    title: 'Batch-Bestellungen mit OOPBUY – Große Mengen clever managen',
    excerpt: 'Für Reseller und Power-Shopper: So verwaltest du hunderte Bestellungen gleichzeitig. Batch-Workflows, Massen-QC und optimierte Versandprozesse.',
    readTime: '8 Min.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Organized%20stacks%20of%20shipping%20labels%20and%20inventory%20sheets%20on%20a%20clean%20industrial%20worktable%20with%20multiple%20parcels%20in%20background%20warm%20warehouse%20lighting%20editorial%20logistics%20photography%20efficient%20operations&width=800&height=500&seq=seo-card-batch&orientation=landscape',
  },
];

const ArticleCard: FC<{ article: SEOArticle }> = ({ article }) => (
  <a
    href={article.slug}
    className="group block bg-background-50 rounded-lg overflow-hidden transition-transform hover:scale-[1.02] cursor-pointer"
  >
    <div className="aspect-[8/5] overflow-hidden">
      <img
        src={article.imageUrl}
        alt={article.title}
        title={article.title}
        className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        loading="lazy"
      />
    </div>
    <div className="p-4 md:p-5">
      <div className="flex items-center gap-2 mb-2">
        <span className="text-xs text-accent-600 bg-accent-100/80 px-2 py-0.5 rounded-full font-label">
          {article.readTime}
        </span>
        <span className="text-xs text-foreground-400">Lesezeit</span>
      </div>
      <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 leading-snug group-hover:text-primary-600 transition-colors">
        {article.title}
      </h3>
      <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
        {article.excerpt}
      </p>
      <span className="inline-flex items-center gap-1 mt-3 text-xs text-primary-600 font-medium">
        Weiterlesen
        <i className="ri-arrow-right-line text-xs"></i>
      </span>
    </div>
  </a>
);

export default function SEOArticlesSection() {
  return (
    <section className="bg-background-200/70 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <p className="text-xs md:text-sm text-foreground-500 uppercase tracking-wider mb-2 font-label">
            SEO Ratgeber & Guides
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            OOPBUY Spreadsheet Ratgeber
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl">
            Alles, was du über den Einkauf mit dem OOPBUY Spreadsheet wissen musst — von der Einrichtung bis zum Versand.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoArticles.map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}